import React from 'react'

export default () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
		<path fillRule="evenodd" d="M8.32 15.68a1.06 1.06 0 0 1-1.51.007 1.095 1.095 0 0 1-.294-.99l.68-3.308H3.15C1.61 11.39.572 9.8 1.173 8.37l2.335-5.496C3.738 2.347 4.253 2 4.826 2h6.445c.788 0 1.432.65 1.432 1.445v7.215c0 .383-.15.751-.415 1.018L8.32 15.68zM15.568 2C16.355 2 17 2.65 17 3.445v5.778c0 .794-.645 1.444-1.432 1.444-.788 0-1.433-.65-1.433-1.444V3.445c0-.795.645-1.445 1.433-1.445z" />
	</svg>
)
